import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';

import { useDeleteCommentMutation, PostAuthor } from 'api';
import { alert } from 'components';
import { useModal } from 'hooks';

export interface Comment {
  id: string;
  author: PostAuthor;
  content: string;
  created_at: string;
  updated_at: string;
}

export function useDeleteComment({ id }: Comment) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { postId = '', taskId = '' } = useParams();

  const {
    isOpen: isDeleteModalOpen,
    handleOpenModal: openDeleteModal,
    handleCloseModal: closeDeleteModal,
  } = useModal();

  const handleCloseDeleteModal = useCallback(() => {
    closeDeleteModal();
  }, [closeDeleteModal]);

  const { deleteCommentMutation, isLoading: isConfirmDeleteLoading } = useDeleteCommentMutation({
    invalidateQueries: ['achievement'],
    onSuccessAction: () => {
      handleCloseDeleteModal();
      alert.success(t('document.list.deleteSuccess'));
      setTimeout(() => {
        navigate(0);
      }, 1000);
    },
  });

  const handleRemoveClick = useCallback(() => {
    openDeleteModal();
  }, [openDeleteModal]);

  const handleDeleteComment = useCallback(() => {
    deleteCommentMutation({
      postId: postId || taskId,
      commentId: id,
    });
  }, [postId, deleteCommentMutation, id, taskId]);

  return {
    isConfirmDeleteLoading,
    isDeleteModalOpen,
    handleCloseDeleteModal,
    handleDeleteComment,
    handleRemoveClick,
  };
}
